import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './store';
import { OptOutStep } from '@/types/common';
import { optOutSlice } from '@/store/slice';
import { api } from '@/store/api';
import { useEffect } from 'react';
import { useToken } from '@/useToken';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export const useOptOut = (): {
  email: string;
  showContent: boolean;
  step: OptOutStep;
  optOut: () => void;
  choseNotToOptOut: () => void;
  isLoading: boolean;
} => {
  const token = useToken();
  const [
    makeRequest,
    { data, isSuccess: tokenSuccessfullyDecoded, isFetching: isFetchingDecode },
  ] = api.useLazyDecodeEmailOptOutQuery();
  const [
    requestOptOut,
    { isError: optOutError, isFetching: isFetchingOptOut },
  ] = api.useLazyRequestEmailOptOutQuery();

  useEffect(() => {
    if (token) {
      void makeRequest({ token });
    }
  }, [makeRequest, token]);

  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.common);

  const choseNotToOptOut = () => {
    dispatch(optOutSlice.actions.setStep('decided-not-to-opt-out'));
  };

  const optOut = async () => {
    if (token) {
      await requestOptOut({ token });
      dispatch(optOutSlice.actions.setStep('opted-out'));
    } else {
      console.error('[useOptOut] Error. No token', { token });
    }
  };

  const decodeRequestIsOk =
    tokenSuccessfullyDecoded &&
    data.type === 'SKIP_RESULT_ATTACHMENT' &&
    !!data.email;
  const hasToken = !!token;
  const noOptOutRequestError = !optOutError;
  return {
    email: data?.email ?? '',
    showContent: hasToken && noOptOutRequestError && decodeRequestIsOk,
    step: state.step,
    isLoading: isFetchingDecode || isFetchingOptOut,
    optOut,
    choseNotToOptOut,
  };
};
